import { TFunction } from 'i18next';

export const makeInputAcceptFormatStr = (acceptKeys: string[], t: TFunction) => {
  const mapper = (key: string) => t(`mime.${key}`);

  return `${[...acceptKeys].map(mapper).join(', ')}`;
};
